<template>
  <section id="podcast" class="vue-podcast-list spacer half bb">
    <div class="title mbig big">Podcasts</div>
    <collapse
        v-for="year in podcast.years"
        :key="year.uid"
        :uid="year.uid"
        :id="year.uid"
        parent="podcast"
        :fold="true"
      >
        <template v-slot:header>
          <div class="first">{{ year.title }}</div>
        </template>
        <template v-slot:content>
          <podcast-item
            v-for="(pod, index) in year.episodes"
            :key="'p-' + index"
            :podcast="pod.embed"
          />
          <div class="pt" v-if="year.text" v-html="year.text"></div>
        </template>
    </collapse>
  </section>
</template>

<script>
import API from "@/api/service";
import Collapse from "@/components/Collapse.vue";
import PodcastItem from "@/components/PodcastItem.vue";
export default {
  components: {
    Collapse,
    PodcastItem,
  },
  data() {
    return {
      podcast: [],
      clicked: false,
      // loaded: false
    };
  },
  created() {
    API.podcast(this.$i18n.locale).then((page) => {
      this.podcast = page.data.result;
      // this.loaded = true;
    });
  },
  methods: {
    openList() {
      this.clicked = !this.clicked;
      this.$router.push({
        path: "/" + this.$i18n.locale + "/podcast",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.click {
  cursor: pointer;
}
</style>
